const ServiceBlock = ({ icon, title, description, bullets, bgImage }) => {
  return (
    <div
      className="service-card"
      style={{
        backgroundImage: ` url(${bgImage})`
      }}
    >
      <div className="service-icon">
        <img src={icon} alt={title} />
      </div>

      <h3>{title}</h3>
      <div className="yellow-line"></div>

      <p className="service-desc">{description}</p>

      <ul>
        {bullets.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceBlock;